import Route from '@ember/routing/route';

export default class VisitorsTrialEndedRoute extends Route {
  titleToken = 'Visitors Subscription Expired';
}
